<template>
    <div class="form-register">
        <template v-if="showForm">
            <form @submit.prevent="submit">
                <!-- Company Profile -->
                <p class="title">Company Profile</p>
                <div class="flex-table bordered">
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 100%;">
                            <div class="input-wrap">
                                <label>Company Name:</label>
                                <input type="text" ref="company_name" v-model="model.company_name">
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>Person Title:</label>
                                <input type="text" ref="person_title" v-model="model.person_title">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 35%;">
                            <div class="input-wrap">
                                <label>First Name:</label>
                                <input type="text" ref="first_name" v-model="model.first_name">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 35%;">
                            <div class="input-wrap">
                                <label>Last Name:</label>
                                <input type="text" ref="last_name" v-model="model.last_name">
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Email:</label>
                                <input type="text" ref="email" v-model="model.email">
                            </div>
                            <div class="error-message text-danger" v-for="(error, key) in errors.email" :key="key">{{ error }}</div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Company Phone:</label>
                                <input type="text" ref="telephone" v-model="model.telephone">
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Fax:</label>
                                <input type="text" ref="fax" v-model="model.fax">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Cellphone:</label>
                                <input type="text" ref="cellphone" v-model="model.cellphone">
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Address:</label>
                                <input type="text" ref="address" v-model="model.address">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Country:</label>
                                <select ref="country" v-model="model.country" @change="model.state = ''">
                                    <option value="">Select</option>
                                    <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>City:</label>
                                <input type="text" ref="city" v-model="model.city">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 40%;">
                            <div class="input-wrap">
                                <label>State:</label>
                                <span ref="state" class="states-wrap w-100">
                                    <input v-show="!states[model.country]" type="text" v-model="model.state">
                                    <select v-show="states[model.country]" v-model="model.state">
                                        <option value="">Select</option>
                                        <option v-for="state in states[model.country]" :key="state" :value="state">{{ state }}</option>
                                    </select>
                                </span>
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>Zip Code:</label>
                                <input type="text" ref="zipcode" v-model="model.zipcode">
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 100%;">
                            <div class="input-wrap">
                                <label>Corporation Type:</label>
                                <select ref="corporation_type" v-model="model.corporation_type">
                                    <option value="">Select</option>
                                    <option>LLC</option>
                                    <option>Partnership</option>
                                    <option>Sole Proprietor</option>
                                    <option>Corporation</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Shipping Address (If Different):</label>
                                <input type="text" ref="shipping_address" v-model="model.shipping_address">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Country:</label>
                                <select ref="shipping_country" v-model="model.shipping_country" @change="model.shipping_state = ''">
                                    <option value="">Select</option>
                                    <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>City:</label>
                                <input type="text" ref="shipping_city" v-model="model.shipping_city">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 40%;">
                            <div class="input-wrap">
                                <label>State:</label>
                                <span ref="shipping_state" class="states-wrap w-100">
                                    <input v-show="!states[model.shipping_country]" type="text" v-model="model.shipping_state">
                                    <select v-show="states[model.shipping_country]" v-model="model.shipping_state">
                                        <option value="">Select</option>
                                        <option v-for="state in states[model.shipping_country]" :key="state" :value="state">{{ state }}</option>
                                    </select>
                                </span>
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>Zip Code:</label>
                                <input type="text" ref="shipping_zipcode" v-model="model.shipping_zipcode">
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <div class="checkbox-wrap mx-auto">
                                    <label class="mr-4">MOD <input type="radio" class="ml-1" value="MOD" name="mod_construction" ref="mod_construction" v-model="model.mod_construction"></label>
                                    <label>New Construction <input type="radio" class="ml-1" value="New Construction" name="mod_construction" v-model="model.mod_construction"></label>
                                </div>
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <select ref="business_type" v-model="model.business_type">
                                    <option value="">Select</option>
                                    <option value="Manufacturer">Manufacturer</option>
                                    <option value="Contractor">Contractor</option>
                                    <option value="Distributor">Distributor</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Company Profile -->

                <!-- Billing Information -->
                <p class="title mt-2">Billing Information</p>
                <div class="flex-table bordered">
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Business Start Date:</label>
                                <div style="width: 100%;" class="datepicker-wrap" ref="business_start_date">
                                    <date-picker value-type="format" v-model="model.business_start_date" :editable="false" :disabled="preview"></date-picker>
                                </div>    
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Company Federal Tax ID#:</label>
                                <input type="text" ref="fed_tax_id" v-model="model.fed_tax_id">
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col">
                            <div class="input-wrap">
                                <label style="flex: 1 0 20%;">Company Sales Tax Status:</label>
                                <div class="checkbox-wrap" style="flex: 1 0 80%;">
                                    <label class="mr-4">Exempt (Resale Certificate) <input type="radio" class="ml-1" name="sales_tax_type" value="Exempt" ref="sales_tax_type" v-model="model.sales_tax_type"></label>
                                    <label>Taxable <input type="radio" class="ml-1" name="sales_tax_type" value="Taxable" v-model="model.sales_tax_type"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Billing Address:</label>
                                <input type="text" ref="billing_address" v-model="model.billing_address">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Country:</label>
                                <select ref="billing_country" v-model="model.billing_country" @change="model.billing_state = ''">
                                    <option value="">Select</option>
                                    <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>City:</label>
                                <input type="text" ref="billing_city" v-model="model.billing_city">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 40%;">
                            <div class="input-wrap">
                                <label>State:</label>
                                <span ref="billing_state" class="states-wrap w-100">
                                    <input v-show="!states[model.billing_country]" type="text" v-model="model.billing_state">
                                    <select v-show="states[model.billing_country]" v-model="model.billing_state">
                                        <option value="">Select</option>
                                        <option v-for="state in states[model.billing_country]" :key="state" :value="state">{{ state }}</option>
                                    </select>
                                </span>
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>Zip Code:</label>
                                <input type="text" ref="billing_zipcode" v-model="model.billing_zipcode">
                            </div>
                        </div>
                    </div>
                    <div ref="ap_contacts">
                        <template v-for="(ap_contact, key) in model.ap_contacts">
                            <div :key="key" class="flex-row">
                                <div class="flex-col" style="flex: 1 0 40%;">
                                    <div class="input-wrap">
                                        <label>AP Contact #{{ key+1 }}:</label>
                                        <input type="text" v-model="ap_contact.name">
                                    </div>
                                </div>
                                <div class="flex-col" style="flex: 1 0 30%;">
                                    <div class="input-wrap">
                                        <label>Email:</label>
                                        <input type="text" v-model="ap_contact.email">
                                    </div>
                                </div>
                                <div class="flex-col" style="flex: 1 0 30%;">
                                    <div class="input-wrap">
                                        <label>Tel:</label>
                                        <input type="text" v-model="ap_contact.telephone">
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <!-- End Billing Information -->

                <!-- Trade References -->
                <p class="title mt-2">Trade References (Use for Credit Terms)</p>
                <div ref="trade_references">
                    <template v-for="(trade_reference, key) in model.trade_references">
                        <div :key="key">
                            <p class="sub-title">Company Reference Name {{ key+1 }}:</p>
                            <div class="flex-table bordered">
                                <div class="flex-row">
                                    <div class="flex-col" style="flex: 1 0 40%;">
                                        <div class="input-wrap">
                                            <label>Company:</label>
                                            <input type="text" v-model="trade_reference.company">
                                        </div>
                                    </div>
                                    <div class="flex-col" style="flex: 1 0 30%;">
                                        <div class="input-wrap">
                                            <label>Address:</label>
                                            <input type="text" v-model="trade_reference.address">
                                        </div>
                                    </div>
                                    <div class="flex-col" style="flex: 1 0 30%;">
                                        <div class="input-wrap">
                                            <label>Country:</label>
                                            <select v-model="trade_reference.country" @change="trade_reference.state = ''">
                                                <option value="">Select</option>
                                                <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <div class="flex-col" style="flex: 1 0 40%;">
                                        <div class="input-wrap">
                                            <label>City:</label>
                                            <input type="text" v-model="trade_reference.city">
                                        </div>
                                    </div>
                                    <div class="flex-col" style="flex: 1 0 30%;">
                                        <div class="input-wrap">
                                            <label>State:</label>
                                            <input v-show="!states[trade_reference.country]" type="text" v-model="trade_reference.state">
                                            <select v-show="states[trade_reference.country]" v-model="trade_reference.state">
                                                <option value="">Select</option>
                                                <option v-for="state in states[trade_reference.country]" :key="state" :value="state">{{ state }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="flex-col" style="flex: 1 0 30%;">
                                        <div class="input-wrap">
                                            <label>Zip Code:</label>
                                            <input type="text" v-model="trade_reference.zipcode">
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-row">
                                    <div class="flex-col" style="flex: 1 0 40%;">
                                        <div class="input-wrap">
                                            <label>Contact:</label>
                                            <input type="text" v-model="trade_reference.contact">
                                        </div>
                                    </div>
                                    <div class="flex-col" style="flex: 1 0 30%;">
                                        <div class="input-wrap">
                                            <label>Email:</label>
                                            <input type="text" v-model="trade_reference.email">
                                        </div>
                                    </div>
                                    <div class="flex-col" style="flex: 1 0 30%;">
                                        <div class="input-wrap">
                                            <label>Tel:</label>
                                            <input type="text" v-model="trade_reference.telephone">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- End Trade References -->

                <!-- Freight Account -->
                <p class="title mt-2">Freight Account (Customer Arranges Shipping)</p>
                <div class="flex-table bordered">
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Customer Freight Company:</label>
                                <input type="text" ref="freight_company" v-model="model.freight_company">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%;">
                            <div class="input-wrap">
                                <label>Contact Name:</label>
                                <input type="text" ref="freight_contact_name" v-model="model.freight_contact_name">
                            </div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 40%;">
                            <div class="input-wrap">
                                <label>Freight Account #:</label>
                                <input type="text" ref="freight_account_no" v-model="model.freight_account_no">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>Email:</label>
                                <input type="text" ref="freight_email" v-model="model.freight_email">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="input-wrap">
                                <label>Tel:</label>
                                <input type="text" ref="freight_telephone" v-model="model.freight_telephone">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Freight Account -->

                <p class="text-center mt-4 mb-4">*If no resell tax certificate is submitted, customer is agreeing to include sales tax on all orders and take ownership of shipment FOB Memphis.</p>
                
                <!-- Certificate -->
                <!-- NY Certificate -->
                <div v-show="model.state == 'New York'">
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <img src="/api/public/img/new_york_logo.png" style="width: 100%; max-width: 140px;">
                        </div>
                        <div class="flex-col" style="flex: 1 0 40%;">
                            <div style="font-size: 12px;">Department of Taxation and Finance</div>
                            <div style="font-size: 16px;"><b>New York State and Local Sales and Use Tax</b></div>
                            <div style="font-size: 24px;"><b>Resale Certificate</b></div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 30%;">
                            <div class="text-right" style="font-size: 24px;"><b>ST-120</b></div>
                            <div class="text-right" style="font-size: 14px;">(6/18)</div>
                        </div>
                    </div>

                    <div class="flex-table bordered mt-4">
                        <div class="flex-row">
                            <div class="flex-col" style="flex: 1 0 50%;">
                                <div class="input-wrap">
                                    <label>Name of seller</label>
                                    <input type="text" ref="certificate_ny_seller_name" v-model="model.certificate_ny_seller_name">
                                </div>
                            </div>
                            <div class="flex-col" style="flex: 1 0 50%;">
                                <div class="input-wrap">
                                    <label>Name of purchaser</label>
                                    <input type="text" ref="certificate_ny_purchaser_name" v-model="model.certificate_ny_purchaser_name">
                                </div>
                            </div>
                        </div>
                        <div class="flex-row">
                            <div class="flex-col" style="flex: 1 0 50%;">
                                <div class="input-wrap">
                                    <label>Street address</label>
                                    <input type="text" ref="certificate_ny_seller_address" v-model="model.certificate_ny_seller_address">
                                </div>
                            </div>
                            <div class="flex-col" style="flex: 1 0 50%;">
                                <div class="input-wrap">
                                    <label>Street address</label>
                                    <input type="text" ref="certificate_ny_purchaser_address" v-model="model.certificate_ny_purchaser_address">
                                </div>
                            </div>
                        </div>
                        <div class="flex-row">
                            <div class="flex-col" style="flex: 1 0 25%;">
                                <div class="input-wrap">
                                    <label>City:</label>
                                    <input type="text" ref="certificate_ny_seller_city" v-model="model.certificate_ny_seller_city">
                                </div>
                            </div>
                            <div class="flex-col" style="flex: 1 0 25%;">
                                <div class="input-wrap">
                                    <label>Zip Code:</label>
                                    <input type="text" ref="certificate_ny_seller_zipcode" v-model="model.certificate_ny_seller_zipcode">
                                </div>
                            </div>
                            <div class="flex-col" style="flex: 1 0 25%;">
                                <div class="input-wrap">
                                    <label>City:</label>
                                    <input type="text" ref="certificate_ny_purchaser_city" v-model="model.certificate_ny_purchaser_city">
                                </div>
                            </div>
                            <div class="flex-col" style="flex: 1 0 25%;">
                                <div class="input-wrap">
                                    <label>Zip Code:</label>
                                    <input type="text" ref="certificate_ny_purchaser_zipcode" v-model="model.certificate_ny_purchaser_zipcode">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="checkbox-wrap mt-4">
                        <label class="mr-4"><input type="radio" class="ml-1" value="Single-use certificate" name="certificate_ny_certificate_type" ref="certificate_ny_certificate_type" v-model="model.certificate_ny_certificate_type"> Single-use certificate</label>
                        <label><input type="radio" class="ml-1" value="Blanket certificate" name="certificate_ny_certificate_type" v-model="model.certificate_ny_certificate_type"> Blanket certificate</label>
                    </div>
                    <div class="mt-2">Temporary vendors must issue a single-use certificate.</div>

                    <p class="title mt-2 pl-0">Purchaser information</p>
                    <div class="flex-row">
                        <div class="flex-col" style="flex: 1 0 50%">
                            <div class="input-wrap">
                                <label>I am engaged in the business of</label>
                                <input type="text" class="border-bottom border-dark" ref="certificate_ny_purchaser_business_type" v-model="model.certificate_ny_purchaser_business_type">
                            </div>
                        </div>
                        <div class="flex-col" style="flex: 1 0 50%">
                            <div class="input-wrap">
                                <label>and principally sell</label>
                                <input type="text" class="border-bottom border-dark" ref="certificate_ny_purchaser_product_type" v-model="model.certificate_ny_purchaser_product_type">
                            </div>
                        </div>
                    </div>
                    <p class="text-center"><i>(Contractors may not use this certificate to purchase materials and supplies.)</i></p>
                    
                    <div style="border-top: 2px solid #000;"></div>

                    <!-- Part 1 -->
                    <p class="title pl-0">Part 1 – To be completed by registered New York State sales tax vendors</p>
                    <p><b>I certify that I am:</b></p>
                    <ul>
                        <li class="mb-1">
                            <label class="d-flex">
                                <input type="radio" class="mt-1" value="yes" name="certificate_ny_is_state_vendor" ref="certificate_ny_is_state_vendor" v-model="model.certificate_ny_is_state_vendor">
                                <div class="ml-1 w-100">
                                    a New York State vendor (including a hotel operator or a dues or admissions recipient), show vendor or entertainment vendor. My valid Certificate of Authority number is
                                    <input type="text" class="reg-input border-bottom border-dark" style="max-width: 240px;" ref="certificate_ny_vendor_coa_num" v-model="model.certificate_ny_vendor_coa_num" @click="model.certificate_ny_is_state_vendor = 'yes'">
                                </div>
                            </label>
                        </li>
                        <li>
                            <label class="d-flex">
                                <input type="radio" class="mt-1" value="temporary" name="certificate_ny_is_state_vendor" ref="certificate_ny_is_state_vendor" v-model="model.certificate_ny_is_state_vendor">
                                <div class="ml-1 w-100">
                                    a New York State temporary vendor. My valid Certificate of Authority number is
                                    <input type="text" class="reg-input border-bottom border-dark" style="max-width: 240px;" ref="certificate_ny_temp_vendor_coa_num" v-model="model.certificate_ny_temp_vendor_coa_num" @click="model.certificate_ny_is_state_vendor = 'temporary'">
                                    and expires on
                                    <div class="datepicker-wrap d-inline-block reg-date" ref="certificate_ny_temp_vendor_coa_exp" @click="model.certificate_ny_is_state_vendor = 'temporary'">
                                        <date-picker value-type="format" v-model="model.certificate_ny_temp_vendor_coa_exp" :editable="false" :disabled="preview" input-class="mx-input border-bottom border-dark"></date-picker>
                                    </div>
                                </div>
                            </label>
                        </li>
                    </ul>
                    <p class="mt-2"><b>I am purchasing:</b></p>
                    <ul class="certificate_ny_purchasing" ref="certificate_ny_purchasing">
                        <li>
                            <label class="d-flex">
                                <input type="checkbox" value="a" @change="selectCertNYPurchasing($event, 'a')"> 
                                <div class="ml-1 w-100">
                                    <b>A.</b> Tangible personal property (other than motor fuel or diesel motor fuel)
                                    <ul style="list-style: disc;" class="ml-4">
                                        <li>for resale in its present form or for resale as a physical component part of tangible personal property;</li>
                                        <li>
                                            for use in performing taxable services where the property will become a physical component part of the property upon which the
                                            services will be performed, or the property will actually be transferred to the purchaser of the taxable service in conjunction with the
                                            performance of the service; or
                                        </li>
                                    </ul>
                                </div>
                            </label>
                        </li>
                        <li>
                            <label class="d-flex">
                                <input type="checkbox" value="b" @change="selectCertNYPurchasing($event, 'b')">
                                <div class="ml-1 w-100">
                                    <b>B.</b> A service for resale, including the servicing of tangible personal property held for sale.
                                </div>
                            </label>
                        </li>
                        <li>
                            <label class="d-flex">
                                <input type="checkbox" value="c" @change="selectCertNYPurchasing($event, 'c')"> 
                                <div class="ml-1 w-100">
                                    <b>C.</b> Restaurant-type food, heated food, or heated drink for resale.
                                </div>    
                            </label>
                        </li>
                    </ul>
                    <!-- End Part 1 -->

                    <div style="border-top: 2px solid #000;" class="mt-2"></div>
                    
                    <!-- Part 2 -->
                    <p class="title pl-0">Part 2 – To be completed by non-New York State purchasers</p>
                    <div>
                        <b>I certify that I am</b> not registered nor am I required to be registered as a New York State sales tax vendor. I am registered to collect sales tax or value added tax (VAT) in the following state/jurisdiction
                        <input type="text" class="reg-input border-bottom border-dark" style="max-width: 240px;" ref="certificate_ny_non_ny_state" v-model="model.certificate_ny_non_ny_state">
                        and have been issued the following registration number
                        <input type="text" class="reg-input border-bottom border-dark" style="max-width: 240px;" ref="certificate_ny_non_ny_reg_num" v-model="model.certificate_ny_non_ny_reg_num">
                        (If sales tax or VAT registration is not required and a registration number is not issued by your home jurisdiction, indicate the location of your business and write <b><i>not applicable</i></b> on the line requesting the registration number.)
                    </div>
                    <p class="mt-2"><b>I am purchasing:</b></p>
                    <ul class="certificate_ny_purchasing">
                        <li>
                            <label class="d-flex">
                                <input type="checkbox" value="d" @change="selectCertNYPurchasing($event, 'd')">
                                <div class="ml-1 w-100">
                                    <b>D.</b> Tangible personal property (other than motor fuel or diesel motor fuel) for resale, and it is being delivered directly by the seller to my customer or to an unaffiliated fulfillment services provider in New York State.
                                </div>
                            </label>
                        </li>
                        <li>
                            <label class="d-flex">
                                <input type="checkbox" value="e" @change="selectCertNYPurchasing($event, 'e')"> 
                                <div class="ml-1 w-100">
                                    <b>E.</b> Tangible personal property for resale that will be resold from a business located outside New York State.
                                </div>
                            </label>
                        </li>
                    </ul>
                    <!-- End Part 2 -->

                    <div style="border-top: 2px solid #000;" class="mt-2"></div>

                    <div class="flex-table bordered mt-4">
                        <div class="flex-row">
                            <div class="flex-col" style="flex: 1 0 100%;">
                                <div class="input-wrap">
                                    <label>Name and title of owner, partner, or authorized person of purchaser</label>
                                    <input type="text" ref="certificate_ny_auth_person" v-model="model.certificate_ny_auth_person">
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="!preview">
                        <p class="mt-4">
                            <input type="checkbox" class="mr-1" ref="i_certify_ny" v-model="model.i_certify_ny"> 
                            I certify that the above statements are true, complete, and correct, and that no material information has been omitted. I make these
                            statements and issue this exemption certificate with the knowledge that this document provides evidence that state and local sales or use taxes
                            do not apply to a transaction or transactions for which I tendered this document and that willfully issuing this document with the intent to evade
                            any such tax may constitute a felony or other crime under New York State Law, punishable by a substantial fine and a possible jail sentence.
                            I understand that this document is required to be filed with, and delivered to, the vendor as agent for the Tax Department for the purposes of
                            Tax Law section 1838 and is deemed a document required to be filed with the Tax Department for the purpose of prosecution of offenses. I also
                            understand that the Tax Department is authorized to investigate the validity of tax exclusions or exemptions claimed and the accuracy of any
                            information entered on this document.
                        </p>
                        <div class="mt-4">
                            <a href="/api/public/files/instructions/Customer_Registration_Form_Instructions_NY.pdf" target="_blank" class="pdf-link-full"><i class="fa fa-file-pdf-o"></i> Instructions</a>
                        </div>
                        <p class="mt-4 text-center"><b>Substantial penalties will result from misuse of this certificate.</b></p>
                    </template>
                    
                </div>
                <!-- End NY Certificate -->

                <!-- Other Certificate -->
                <div v-show="model.state != 'New York'">
                    <p class="title text-center mt-4">UNIFORM SALES & USE TAX RESALE CERTIFICATE - MULTIJURISDICTION</p>
                    <p class="mt-2">
                        The below-listed states have indicated that this certificate is acceptable as a resale/exemption certificate for sales/use tax, subject to the instructions
                        and notes on pages 2─6. The issuing Buyer and the recipient Seller have the responsibility to determine the proper use of this certificate under applicable 
                        laws in each state, as these may change from time to time. This form was revised as of December 9, 2020.
                    </p>

                    <div class="input-wrap mt-4">
                        <label>Issued to Seller:</label>
                        <input type="text" class="border-bottom border-dark" ref="certificate_seller_name" v-model="model.certificate_seller_name">
                    </div>
                    <div class="input-wrap">
                        <label>Address:</label>
                        <input type="text" class="border-bottom border-dark" ref="certificate_seller_address" v-model="model.certificate_seller_address">
                    </div>

                    <div class="row certify-table mt-4 mb-4">
                        <div class="col-md-7">
                            <p>I certify that:</p>
                            <div class="input-wrap">
                                <label>Name of Firm (Buyer):</label>
                                <input type="text" class="border-bottom border-dark" ref="certificate_buyer_name" v-model="model.certificate_buyer_name">
                            </div>
                            <div class="input-wrap mb-4">
                                <label>Address:</label>
                                <textarea class="border-bottom border-dark" ref="certificate_buyer_address" v-model="model.certificate_buyer_address"></textarea>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="registered_as_wrap">
                                <p>is engaged or is registered as a</p>
                                <ul>
                                    <li><label><input type="radio" name="registered_as" value="Wholesaler" ref="certificate_buyer_business_type" v-model="model.certificate_buyer_business_type"> Wholesaler</label></li>
                                    <li><label><input type="radio" name="registered_as" value="Retailer" v-model="model.certificate_buyer_business_type"> Retailer</label></li>
                                    <li><label><input type="radio" name="registered_as" value="Manufacturer" v-model="model.certificate_buyer_business_type"> Manufacturer</label></li>
                                    <li><label><input type="radio" name="registered_as" value="Seller" v-model="model.certificate_buyer_business_type"> Seller</label></li>
                                    <li><label><input type="radio" name="registered_as" value="Lessor" v-model="model.certificate_buyer_business_type"> Lessor (see notes on pages 2─4)</label></li>
                                    <li>
                                        <label>
                                            <input type="radio" name="registered_as" value="Other" v-model="model.certificate_buyer_business_type">Other
                                            <div class="input-wrap ml-1">
                                                <input type="text" placeholder="Specify" class="border-bottom border-dark" 
                                                    ref="certificate_buyer_business_type_specify" 
                                                    v-model="model.certificate_buyer_business_type_specify"
                                                    @click="model.certificate_buyer_business_type = 'Other'"
                                                >
                                            </div>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <p class="mt-4 mb-4">
                        and is registered for sales/use tax with the below-listed states and cities within which Seller would deliver purchases to Buyer and that any such
                        purchases are for wholesale, resale, or ingredients or components of a new product or service to be resold, leased, or rented in the normal course of
                        business. Buyer is in the business of wholesaling, retailing, manufacturing, leasing (renting), or selling the following:
                    </p>
                
                    <div class="input-wrap">
                        <label>Description of Business:</label>
                        <input type="text" class="border-bottom border-dark" ref="certificate_buyer_business_description" v-model="model.certificate_buyer_business_description">
                    </div>

                    <div class="row mt-1">
                        <div class="col-md-12">
                            <label>General description of tangible property or taxable services to be purchased from the Seller:</label>
                            <div class="input-wrap">
                                <textarea class="border-bottom border-dark" ref="certificate_buyer_property_service_description" v-model="model.certificate_buyer_property_service_description"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row no-gutters states-table mt-4 mb-4" ref="certificate_state_seller_permit">
                        <div class="col-md-6">
                            <table>
                                <thead>
                                    <th>State</th>
                                    <th>State Registration, Seller’s Permit, or ID Number of Purchaser</th>
                                </thead>
                                <tbody>
                                    <template v-for="(permit, key) in model.certificate_state_seller_permit">
                                        <template v-if="key < 19">
                                            <tr :key="key">
                                                <td style="width: 15%;"><label>{{ permit.state }}<sup>{{ permit.num }}</sup></label></td>
                                                <td style="width: 85%;"><div class="input-wrap"><input type="text" v-model="permit.value"></div></td>
                                            </tr>
                                        </template>
                                    </template>
                                </tbody>
                                <tfoot>
                                    <tr><td colspan="2">&nbsp;</td></tr>
                                </tfoot>
                            </table>
                        </div>
                        <div class="col-md-6">
                            <table>
                                <thead>
                                    <th>State</th>
                                    <th>State Registration, Seller’s Permit, or ID Number of Purchaser</th>
                                </thead>
                                <tbody>
                                    <template v-for="(permit, key) in model.certificate_state_seller_permit">
                                        <template v-if="key >= 19">
                                            <tr :key="key">
                                                <td style="width: 15%;"><label>{{ permit.state }}<sup>{{ permit.num }}</sup></label></td>
                                                <td style="width: 85%;"><div class="input-wrap"><input type="text" v-model="permit.value"></div></td>
                                            </tr>
                                        </template>
                                    </template>
                                    <tr>
                                        <td style="width: 15%;">&nbsp;</td>
                                        <td style="width: 85%;"><div class="input-wrap"><input type="text" readonly></div></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 15%;">&nbsp;</td>
                                        <td style="width: 85%;"><div class="input-wrap"><input type="text" readonly></div></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr><td colspan="2">&nbsp;</td></tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <template v-if="!preview">
                        <p class="mt-2">
                            <input type="checkbox" class="mr-1" ref="i_certify" v-model="model.i_certify"> 
                            I further certify that if any property or service so purchased tax-free is used or consumed by Buyer so as to make it subject to sales/use tax, Buyer
                            will pay the tax due directly to the proper taxing authority when state law so provides or inform the Seller for added tax billing. This certificate shall
                            be a part of each order that Buyer may hereafter give to Seller, unless otherwise specified, and shall be valid until canceled by Buyer in writing or
                            revoked by the city or state.
                        </p>
                        <p class="mt-2">Under penalties of perjury, I swear or affirm that the information on this form is true and correct as to every material matter.</p>
                        <div class="mt-4">
                            <a href="/api/public/files/instructions/Customer_Registration_Form_Instructions.pdf" target="_blank" class="pdf-link-full"><i class="fa fa-file-pdf-o"></i> Instructions</a>
                        </div>
                    </template>
                </div>
                <!-- Other Certificate -->
                <!-- End Certificate -->

                <template v-if="!preview">
                    <div class="mt-4 mb-4 text-right">
                        <button class="btn btn-primary" type="submit" :disabled="isLoading">
                            <template v-if="isLoading"><span class="fa fa-spinner fa-pulse"></span></template>
                            <template v-else>Submit</template>
                        </button>
                    </div>
                </template>
                
            </form>
        </template>
        <template v-else>
            <p class="text-center success-msg">Thank You! We will contact you soon.</p>
        </template>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    components: { 
        DatePicker
    },
    data() {
        return {
            showForm: true,
            isLoading: false,
            countries: window.countries,
            states: window.states,
            errors: [],
            model: {
                company_name: '',
                person_title: '',
                first_name: '',
                last_name: '',
                email: '',
                telephone: '',
                fax: '',
                cellphone: '',
                address: '',
                city: '',
                state: '',
                zipcode: '',
                country: '',
                corporation_type: '',
                shipping_address: '',
                shipping_city: '',
                shipping_state: '',
                shipping_zipcode: '',
                shipping_country: '',
                mod_construction: '',
                business_type: '',
                business_start_date: '',
                fed_tax_id: '',
                sales_tax_type: '',
                billing_address: '',
                billing_city: '',
                billing_state: '',
                billing_zipcode: '',
                billing_country: '',
                ap_contacts: [
                    { name: '', email: '', telephone: '' },
                    { name: '', email: '', telephone: '' }
                ],
                trade_references: [
                    { company: '', address: '', city: '', state: '', zipcode: '', country: '', contact: '', email: '', telephone: '' },
                    { company: '', address: '', city: '', state: '', zipcode: '', country: '', contact: '', email: '', telephone: '' },
                    { company: '', address: '', city: '', state: '', zipcode: '', country: '', contact: '', email: '', telephone: '' }
                ],
                freight_company: '',
                freight_contact_name: '',
                freight_account_no: '',
                freight_email: '',
                freight_telephone: '',
                certificate_seller_name: '',
                certificate_seller_address: '',
                certificate_buyer_name: '',
                certificate_buyer_address: '',
                certificate_buyer_business_type: '',
                certificate_buyer_business_type_specify: '',
                certificate_buyer_business_description: '',
                certificate_buyer_property_service_description: '',
                certificate_state_seller_permit: [
                    { state: 'AL', num: '1', value: '' },
                    { state: 'AR', num: '', value: '' },
                    { state: 'AZ', num: '2', value: '' },
                    { state: 'CA', num: '3', value: '' },
                    { state: 'CO', num: '4,5', value: '' },
                    { state: 'CT', num: '6', value: '' },
                    { state: 'FL', num: '7', value: '' },
                    { state: 'GA', num: '8', value: '' },
                    { state: 'HI', num: '4,9', value: '' },
                    { state: 'ID', num: '10', value: '' },
                    { state: 'IL', num: '4,11', value: '' },
                    { state: 'IA', num: '', value: '' },
                    { state: 'KS', num: '12', value: '' },
                    { state: 'KY', num: '13', value: '' },
                    { state: 'ME', num: '14', value: '' },
                    { state: 'MD', num: '15', value: '' },
                    { state: 'MI', num: '16', value: '' },
                    { state: 'MN', num: '17', value: '' },
                    { state: 'MO', num: '18', value: '' },
                    { state: 'NE', num: '', value: '' },
                    { state: 'NJ', num: '', value: '' },
                    { state: 'NM', num: '4,19', value: '' },
                    { state: 'NC', num: '20', value: '' },
                    { state: 'ND', num: '', value: '' },
                    { state: 'OH', num: '21', value: '' },
                    { state: 'OK', num: '22', value: '' },
                    { state: 'PA', num: '23', value: '' },
                    { state: 'RI', num: '24', value: '' },
                    { state: 'SC', num: '', value: '' },
                    { state: 'SD', num: '25', value: '' },
                    { state: 'TN', num: '26', value: '' },
                    { state: 'TX', num: '27', value: '' },
                    { state: 'UT', num: '', value: '' },
                    { state: 'VT', num: '28', value: '' },
                    { state: 'WA', num: '29', value: '' },
                    { state: 'WI', num: '30', value: '' }
                ],
                certificate_ny_seller_name: '',
                certificate_ny_seller_address: '',
                certificate_ny_seller_city: '',
                certificate_ny_seller_zipcode: '',
                certificate_ny_purchaser_name: '',
                certificate_ny_purchaser_address: '',
                certificate_ny_purchaser_city: '',
                certificate_ny_purchaser_zipcode: '',
                certificate_ny_certificate_type: '',
                certificate_ny_is_state_vendor: '',
                certificate_ny_purchaser_business_type: '',
                certificate_ny_purchaser_product_type: '',
                certificate_ny_vendor_coa_num: '',
                certificate_ny_temp_vendor_coa_num: '',
                certificate_ny_temp_vendor_coa_exp: '',
                certificate_ny_purchasing: [],
                certificate_ny_non_ny_state: '',
                certificate_ny_non_ny_reg_num: '',
                certificate_ny_auth_person: '',
                i_certify: false,
                i_certify_ny: false
            }
        }
    },
    props: {
        registration_obj: Object,
        preview: Boolean
    },
    watch: {
        registration_obj(v) {
            this.model = v

            if(this.preview) {
                let inputs = document.querySelectorAll('.form-register input[type=text], .form-register textarea, .form-register select')
                let radios = document.querySelectorAll('.form-register input[type=radio], .form-register .radio')
                let checkboxes = document.querySelectorAll('.form-register input[type=checkbox], .form-register .checkbox')

                inputs.forEach((elem) => {
                    elem.setAttribute('readonly', true)
                    elem.setAttribute('disabled', true)
                    elem.style.opacity = 1
                })

                radios.forEach((elem) => {
                    let value = elem.value || elem.dataset.value
                    let check = document.createElement('span')
                    check.classList = 'fa fa-circle-o mr-1 radio'
                    check.dataset.value = value

                    if(value == this.model.mod_construction
                        || value == this.model.sales_tax_type
                        || value == this.model.certificate_buyer_business_type
                        || value == this.model.certificate_ny_certificate_type
                        || value == this.model.certificate_ny_is_state_vendor
                    ) {
                        check.classList = 'fa fa-circle mr-1 radio'
                    }
                    elem.parentNode.replaceChild(check, elem)
                })

                checkboxes.forEach((elem) => {
                    let value = elem.value || elem.dataset.value
                    let check = document.createElement('span')
                    check.classList = 'fa fa-square-o mr-1 checkbox'
                    check.dataset.value = value

                    if(this.model.certificate_ny_purchasing) {
                        this.model.certificate_ny_purchasing.forEach((selected) => {
                            if(value == selected) {
                                check.classList = 'fa fa-check-square mr-1 checkbox'
                            }
                        })
                    }
                    
                    elem.parentNode.replaceChild(check, elem)
                })
            }
        }
    },
    methods: {
        submit() {
            if(!this.preview) {
                this.isLoading = true
                this.$http.post('/api/user_registrations', this.model)
                    .then(() => {
                        this.showForm = false
                        this.isLoading = false
                    })
                    .catch(error => {
                        if(error.response.data.message == 'validation_error') {
                            this.errors = error.response.data.errors
                            this.validation_error(error.response.data.errors)
                        }
                        this.isLoading = false
                    })
            }
        },
        selectCertNYPurchasing(event) {
            if(event.target.checked) {
                this.model.certificate_ny_purchasing.push(event.target.value)
            } else {
                this.model.certificate_ny_purchasing.splice(
                    this.model.certificate_ny_purchasing.indexOf(event.target.value),
                    1
                )
            }
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('.hasError')).forEach(function(el) { 
                el.classList.remove('hasError');
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                        ref.scrollIntoView()
                    }
                }
            }

            if(Object.keys(errors).length == 1) {
                alert(errors[Object.keys(errors)[0]][0])
            } else {
                alert('Please fill all required data.')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.success-msg {
    margin-top: 10em;
}
p {
    margin: 0;
    padding: 0;
}
label {
    margin: 0;
}
.title {
    font-weight: bold;
    font-size: 16px;
    margin: 0;
    padding: 0 4px;
}
.sub-title {
    margin: 0;
    padding: 0 4px;
}
.input-wrap {
    display: flex;
    label {
        flex: 1 0 auto;
    }
    .mx-datepicker::v-deep {
        width: 100%;
    }
    input[type=text], input[type=date], select, textarea, .mx-datepicker::v-deep .mx-input {
        padding: 4px;
        background: #F1F3FF;
        border: 0;
        outline: none;
        width: 100%;
        height: 26px;
        border-radius: 0;
        color: #000;
        &:focus {
            background: #FFF;
        }
    }
    textarea {
        height: 80px;
    }
}
.reg-input, .reg-date .mx-datepicker::v-deep .mx-input {
    padding: 4px;
    background: #F1F3FF;
    border: 0;
    outline: none;
    width: 100%;
    height: 26px;
    border-radius: 0;
    color: #000;
    &:focus {
        background: #FFF;
    }
}
.form-register {
    padding: 0 8px;
    .flex-table {
        &.bordered {
            .flex-row {
                border-top: 1px solid #000;
                border-right: 1px solid #000;
                &:last-child {
                    border-bottom: 1px solid #000;
                }
                .flex-col {
                    border-left: 1px solid #000;
                }
            }
        }
    }
    .flex-row {
        display: flex;
        .flex-col {
            flex: 1 0 100%;
            .input-wrap {
                label {
                    padding: 4px;
                }
            }
            .checkbox-wrap mx-auto {
                display: flex;
                align-items: center;
                label {
                    display: flex;
                    align-items: center;
                    flex: none;
                }
            }
        }
    }
    .states-table {
        .col-md-6 {
            &:first-child {
                th, td {
                    border-right: 0;
                }
            }
        }
        table {
            width: 100%;
            th {
                background: #CCDFB2;
                padding: 4px;
                border: 1px solid #000;
            }
            td {
                border: 1px solid #000;
                label {
                    padding: 4px;
                }
            }
            tfoot {
                td {
                    background: #CCDFB2;
                    height: 24px;
                }
            }
        }
    }
    .certify-table {
        .registered_as_wrap {
            width: 230px;
            margin: 0 auto;
            ul {
                list-style: none;
                padding: 0;
                margin: 0;
                li {
                    padding: 4px 0;
                    label {
                        display: flex;
                        align-items: center;
                        input[type=radio] {
                            margin-right: 4px;
                        }
                    }
                }
            }
        }
    }
}
.pdf-link-full {
    display: inline-block;
    border: 1px solid blue;
    padding: 0 10px;
    line-height: 30px;
    color: #0000cd;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0.1px;
    text-decoration: none;
    &:hover, &:focus {
        color: #0000cd;
        text-decoration: none;
    }
    i {
        background: blue;
        color: #FFF;
        padding: 8px 10px 9px;
        font-size: 14px;
        margin: -6px 6px -6px -10px;
    }
}
.certificate_ny_purchasing {
    li {
        padding-bottom: 0.2em;
    }
}
.states-wrap {
    &.hasError {
        border: 0 !important;
        input, select {
            border: 2px solid #ffafaf !important;
        }
    }
}
.error-message {
    text-align: center;
    padding: 0.2em;
    font-size: 12px;
}
@media (max-width: 640px) {
    .input-wrap {
        display: block;
    }
}
@media (max-width: 768px) {
    .certify-table {
        .registered_as_wrap {
            margin-left: 0 !important;
        }
    }
    .states-table {
        .col-md-6 {
            &:first-child {
                th, td {
                    border-right: 1px solid #000 !important;
                }
                tfoot {
                    display: none;
                }
            }
            &:last-child {
                thead {
                    display: none;
                }
                tr {
                    &:first-child {
                        td {
                            border-top: 0 !important;
                        }
                    }
                }
            }
        }
    }
}
</style>